var map = {
	"./AhamayGray.png": 7678,
	"./AnniversarySilver.png": 2979,
	"./AuroraGold.png": 906,
	"./BlueTopaz.png": 3898,
	"./DiamondGray.png": 4955,
	"./DolphineBlue.png": 741,
	"./IbiziaBlue.png": 6538,
	"./LagoonBlue.png": 8048,
	"./LightSapphireBlue.png": 7080,
	"./LunaGreen.png": 3885,
	"./MidnightGray.png": 3149,
	"./MochaBrown.png": 5186,
	"./PaleGold.png": 1838,
	"./PalmeBlue.png": 1707,
	"./PureSilver.png": 3569,
	"./RoyalRubie.png": 4130,
	"./SaharaGold.png": 9656,
	"./StardustSilver.png": 3155,
	"./SunstoneRed.png": 3672,
	"./VelvetGreen.png": 6073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7877;